<template>
  <div>
    <div class="contact-view">
      <div class="contact-header">
        <span class="title-watermark">CONTACT US</span>
        <h1 class="page-title">联系我们</h1>
        <div class="desc">欢迎与海南鼎昂建筑工程有限公司取得联系</div>
      </div>
      <div class="contact-main">
        <div class="contact-info card">
          <h3>联系方式</h3>
          <div class="info-list">
            <div class="info-item"><span>地址：</span>海南省三亚市崖州区兴滨三横路椰岛阳光花园A区立宇办公楼三楼</div>
            <div class="info-item">
              <span>电话：</span>
              <a href="tel:15308032337" class="phone-link">15308032337</a>
            </div>
            <div class="info-item">
              <span>邮箱：</span>
              <a href="mailto:wanglin@hnda2022.com" class="email-link">wanglin@hnda2022.com</a>
            </div>
            <div class="info-item"><span>网址：</span>www.hnda2022.com</div>
          </div>
        </div>
        <div class="contact-map card">
          <div id="baidu-map" class="baidu-map"></div>
        </div>
      </div>
      <div class="contact-form card contact-form-row">
        <h3>在线留言</h3>
        <form @submit.prevent="handleSubmit">
          <input type="text" v-model="form.name" placeholder="您的姓名" :class="{ error: errors.name }" />
          <div v-if="errors.name" class="error-msg">{{ errors.name }}</div>
          <input type="text" v-model="form.phone" placeholder="联系电话" :class="{ error: errors.phone }" />
          <div v-if="errors.phone" class="error-msg">{{ errors.phone }}</div>
          <textarea v-model="form.message" placeholder="留言内容" :class="{ error: errors.message }"></textarea>
          <div v-if="errors.message" class="error-msg">{{ errors.message }}</div>
          <button type="submit">提交</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { sendContactMessage } from '../api/contact';
export default {
  name: 'ContactView',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        message: ''
      },
      errors: {}
    };
  },
  mounted() {
    this.loadBaiduMap();
  },
  methods: {
    loadBaiduMap() {
      if (window.BMap) {
        this.initMap();
        return;
      }
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://api.map.baidu.com/api?v=3.0&ak=R3qMWGBMN0r0ogCNn2STxTCOYofCxLWS&callback=onBMapCallback';
      window.onBMapCallback = this.initMap;
      document.body.appendChild(script);
    },
    initMap() {
      // 公司坐标（以三亚崖州区为例，可根据实际调整）109.184899,18.360524
      const point = new window.BMap.Point(109.184899, 18.360524);
      const map = new window.BMap.Map('baidu-map');
      map.centerAndZoom(point, 16);
      map.enableScrollWheelZoom(true);
      const marker = new window.BMap.Marker(point);
      map.addOverlay(marker);
      marker.setAnimation(window.BMAP_ANIMATION_BOUNCE);
      const label = new window.BMap.Label('海南鼎昂建筑工程有限公司', {
        offset: new window.BMap.Size(20, -20)
      });
      marker.setLabel(label);
    },
    validate() {
      const errors = {};
      if (!this.form.name.trim()) {
        errors.name = '请输入姓名';
      }
      if (!this.form.phone.trim()) {
        errors.phone = '请输入联系电话';
      } else if (!/^1[3-9]\d{9}$/.test(this.form.phone.trim())) {
        errors.phone = '请输入有效的手机号';
      }
      if (!this.form.message.trim()) {
        errors.message = '请输入留言内容';
      }
      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    showTip(msg, type = 'success') {
      // 清除之前的提示框
      const existingTip = document.querySelector('.global-tip-bar');
      if (existingTip) {
        existingTip.remove();
      }

      // 创建新的提示框
      const tipBar = document.createElement('div');
      tipBar.className = `global-tip-bar ${type}`;
      tipBar.innerHTML = `
        ${msg}
        <button class="tip-close" onclick="this.parentElement.remove()">×</button>
      `;

      // 添加到body
      document.body.appendChild(tipBar);

      // 5秒后自动移除
      setTimeout(() => {
        if (tipBar.parentElement) {
          tipBar.remove();
        }
      }, 5000);
    },
    handleSubmit() {
      if (!this.validate()) return;
      sendContactMessage(this.form)
        .then(res => {
          if (res && res.code === 200) {
            this.showTip('留言提交成功！', 'success');
            this.form = { name: '', phone: '', message: '' };
            this.errors = {};
          } else {
            this.showTip(res.msg || '留言提交失败', 'error');
          }
        })
        .catch(err => {
          let msg = '留言提交失败，请稍后重试';
          if (err && err.msg) msg = err.msg;
          if (err && err.response && err.response.data && err.response.data.msg) msg = err.response.data.msg;
          this.showTip(msg, 'error');
        });
    }
  }
};
</script>

<style scoped>
.contact-view {
  padding: 32px 0 48px 0;
  max-width: 1320px;
  margin: 0 auto;
}

.contact-header {
  position: relative;
  text-align: center;
  margin-bottom: 44px;
  margin-top: 8px;
}

.title-watermark {
  position: absolute;
  left: 50%;
  top: -18px;
  transform: translateX(-50%);
  font-size: 2.8rem;
  font-weight: 900;
  color: #1a2a47;
  opacity: 0.09;
  letter-spacing: 0.18em;
  user-select: none;
  pointer-events: none;
  z-index: 1;
  white-space: nowrap;
}

.page-title {
  position: relative;
  z-index: 2;
  text-align: center;
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a2a47;
  margin-bottom: 12px;
  letter-spacing: 1px;
  margin-top: 0;
}

.desc {
  position: relative;
  z-index: 2;
  color: #555;
  font-size: 1.08rem;
  margin-bottom: 0;
  margin-top: 0;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.contact-main {
  display: flex;
  gap: 64px;
  margin-bottom: 56px;
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.card {
  background: #fff;
  border-radius: 28px;
  box-shadow: 0 8px 36px rgba(30, 60, 120, 0.12);
  padding: 56px 48px 48px 48px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 420px;
}

.contact-info {
  min-width: 400px;
  font-size: 1.18rem;
  align-items: flex-start;
}

.info-list {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.info-item {
  color: #222;
  font-size: 1.18rem;
  line-height: 2.1;
}

.info-item span {
  color: #2563eb;
  font-weight: 600;
  margin-right: 6px;
}

.phone-link {
  color: #222;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s, text-decoration 0.2s;
  cursor: pointer;
  position: relative;
}

.phone-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

.email-link {
  color: #222;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s, text-decoration 0.2s;
  cursor: pointer;
  position: relative;
}

.email-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

/* 移动端电话号码样式 */
@media (max-width: 768px) {
  .phone-link {
    color: #2563eb;
    font-weight: 600;
    text-decoration: underline;
    padding: 4px 8px;
    border-radius: 6px;
    background: rgba(37, 99, 235, 0.1);
    transition: background 0.2s, transform 0.2s;
  }

  .phone-link:hover,
  .phone-link:active {
    background: rgba(37, 99, 235, 0.2);
    transform: scale(1.05);
  }

  .email-link {
    color: #2563eb;
    font-weight: 600;
    text-decoration: underline;
    padding: 4px 8px;
    border-radius: 6px;
    background: rgba(37, 99, 235, 0.1);
    transition: background 0.2s, transform 0.2s;
  }

  .email-link:hover,
  .email-link:active {
    background: rgba(37, 99, 235, 0.2);
    transform: scale(1.05);
  }
}

.contact-map {
  min-width: 400px;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.map-iframe {
  width: 100%;
  height: 420px;
  border: none;
  border-radius: 22px;
  box-shadow: 0 2px 16px rgba(30, 60, 120, 0.10);
}

.contact-form-row {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto 32px auto;
  align-items: center;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contact-form h3 {
  text-align: center;
  font-size: 1.32rem;
  color: #1a2a47;
  margin-bottom: 24px;
}

.contact-form form {
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
}

.contact-form input,
.contact-form textarea {
  padding: 22px 20px;
  border: 1.5px solid #dbeafe;
  border-radius: 18px;
  font-size: 1.22rem;
  background: #f7faff;
  transition: border 0.2s;
  width: 100%;
  box-sizing: border-box;
}

.contact-form input:focus,
.contact-form textarea:focus {
  border-color: #2563eb;
  outline: none;
}

.contact-form input.error,
.contact-form textarea.error {
  border-color: #e74c3c;
  background: #fff0f0;
}

.error-msg {
  color: #e74c3c;
  font-size: 1.08rem;
  margin-bottom: -8px;
  margin-top: -8px;
  padding-left: 2px;
}

.success-msg {
  color: #27ae60;
  font-size: 1.18rem;
  margin-top: 18px;
  text-align: center;
}

.contact-form button {
  padding: 22px 0;
  background: linear-gradient(90deg, #2563eb 0%, #1a2a47 100%);
  color: #fff;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  font-size: 1.28rem;
  font-weight: 700;
  transition: background 0.2s, box-shadow 0.2s, transform 0.15s;
  box-shadow: 0 4px 16px rgba(30, 60, 120, 0.10);
  margin-top: 8px;
  letter-spacing: 2px;
}

.contact-form button:hover {
  background: linear-gradient(90deg, #1a2a47 0%, #2563eb 100%);
  transform: scale(1.04);
  box-shadow: 0 8px 32px rgba(30, 60, 120, 0.16);
}

/* 全局提示框样式 */
:global(.global-tip-bar) {
  position: fixed !important;
  top: 100px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 90%;
  max-width: 600px;
  padding: 16px 24px;
  text-align: center;
  font-size: 1.15rem;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  letter-spacing: 1px;
  transition: all 0.3s ease;
  z-index: 999999 !important;
  animation: slideDown 0.3s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  background: linear-gradient(90deg, #27ae60 0%, #2563eb 100%);
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

:global(.global-tip-bar.success) {
  background: linear-gradient(90deg, #27ae60 0%, #2563eb 100%) !important;
  color: #fff !important;
}

:global(.global-tip-bar.error) {
  background: linear-gradient(90deg, #e74c3c 0%, #f39c12 100%) !important;
  color: #fff !important;
}

:global(.global-tip-bar .tip-close) {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

:global(.global-tip-bar .tip-close:hover) {
  background-color: rgba(255, 255, 255, 0.2);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.static-map-img {
  width: 100%;
  max-width: 600px;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(30, 60, 120, 0.08);
  display: block;
  margin: 0 auto;
}

.baidu-map {
  width: 100%;
  max-width: 600px;
  height: 420px;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(30, 60, 120, 0.08);
  margin: 0 auto;
}

@media (max-width: 1320px) {
  .contact-view {
    max-width: 100%;
    padding: 8px 0 24px 0;
  }

  :global(.global-tip-bar) {
    width: 95%;
    max-width: 90vw;
    top: 80px !important;
    padding: 12px 20px;
    font-size: 1rem;
  }

  :global(.global-tip-bar .tip-close) {
    right: 8px;
    font-size: 1.3rem;
    width: 20px;
    height: 20px;
  }

  .contact-header {
    margin-bottom: 24px;
  }

  .contact-main {
    flex-direction: column;
    gap: 18px;
    margin-bottom: 24px;
    max-width: 100%;
  }

  .card {
    padding: 18px 6px 14px 6px;
    border-radius: 14px;
    min-height: 0;
  }

  .title-watermark {
    font-size: 1.1rem;
    top: -8px;
  }

  .page-title {
    font-size: 1.1rem;
  }

  .desc {
    font-size: 0.98rem;
  }

  .contact-form-row {
    width: 100%;
    margin-bottom: 18px;
    max-width: 100%;
  }

  .map-iframe {
    height: 220px;
    border-radius: 10px;
  }

  .contact-info,
  .contact-map {
    min-width: 0;
  }
}
</style>